'use client';

import { type PropsWithChildren, createContext, useContext, useEffect } from 'react';

import { setAnalyticsContext } from '@/lib/analytics/analyticsContext';
import { type getAssignedRole } from '@/lib/order/utils/getAssignedRole';
import { type Idr } from './types';

type IdrProviderProps = PropsWithChildren<{ idr: Idr | null; assignedRole: ReturnType<typeof getAssignedRole> }>;

const IdrContext = createContext<Idr | null>(null);

export function IdrProvider({ children, idr, assignedRole }: IdrProviderProps) {
	const isNmsc = assignedRole === 'NMSC';

	useEffect(() => {
		setAnalyticsContext({ isNmsc });
	}, [isNmsc]);

	return <IdrContext.Provider value={idr}>{children}</IdrContext.Provider>;
}

export function useIdr() {
	const context = useContext(IdrContext);

	if (typeof context === 'undefined') {
		throw new Error('useIdr must be used within a IdrProvider');
	}

	return context;
}
